export enum ErrorTypeEnum {
  userCanceled = 'User cancelled',
  canceled = 'Canceled',
  paymentCanceled = 'PAYMENT_RESULT_CANCELED',
  timeSlotExpired = 'timeSlotExpired',
  paymentFailed = 'PaymentFailed',
}
